import React from 'react';

const CourseEnrollmentDisplay = ({ enrollments }) => {
  const currentEnrollment = enrollments.find((e) => e.current);
  const previousEnrollments = enrollments.filter((e) => !e.current);

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString();
  };

  return (
    <div className="mb-6 rounded-lg border border-dashed border-brand-500 bg-white p-6 shadow-md dark:bg-navy-900">
      <h3 className="mb-4 text-lg font-semibold text-brand-600 dark:text-white">
        Course Enrollments
      </h3>
      <div className="grid grid-cols-1 gap-4">
        {currentEnrollment ? (
          <div className="rounded-lg border bg-gray-50 p-4 shadow-sm dark:bg-navy-800">
            <p className="font-semibold text-navy-700 dark:text-white">
              Current Enrollment:
            </p>
            <p className="mt-2 text-gray-700 dark:text-gray-300">
              <span className="font-medium text-brand-600 dark:text-brand-400">
                {currentEnrollment.course.courseName} - Batch{' '}
                {currentEnrollment.batch.batchNumber}
              </span>
              <br /> Enrollment Date:{' '}
              {formatDate(currentEnrollment.enrollmentDate)}
              <br /> Status:{' '}
              <span
                className={
                  currentEnrollment.status === 'Active'
                    ? 'text-green-600'
                    : currentEnrollment.status === 'Dropped'
                    ? 'text-red-600'
                    : 'text-yellow-600'
                }
              >
                {currentEnrollment.status}
              </span>
            </p>
          </div>
        ) : (
          <p className="text-gray-500 dark:text-gray-400">
            No current enrollments.
          </p>
        )}

        {/* Previous Enrollments */}
        {previousEnrollments.length > 0 ? (
          <div className="rounded-lg border bg-gray-50 p-4 shadow-sm dark:bg-navy-800">
            <p className="font-semibold text-navy-700 dark:text-white">
              Previous Enrollments:
            </p>
            <ul className="mt-2 list-inside list-disc space-y-2 text-gray-700 dark:text-gray-300">
              {previousEnrollments.map((enrollment) => (
                <li key={enrollment._id} className="leading-relaxed">
                  <span className="font-medium text-brand-600 dark:text-brand-400">
                    {enrollment.course.courseName} - Batch{' '}
                    {enrollment.batch.batchNumber}
                  </span>
                  <br /> Enrollment Date:{' '}
                  {formatDate(enrollment.enrollmentDate)}
                  <br /> Status:{' '}
                  <span
                    className={
                      enrollment.status === 'Active'
                        ? 'text-green-600'
                        : enrollment.status === 'Dropped'
                        ? 'text-red-600'
                        : 'text-yellow-600'
                    }
                  >
                    {enrollment.status}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        ) : (
          <p className="text-gray-500 dark:text-gray-400">
            No previous enrollments.
          </p>
        )}
      </div>
    </div>
  );
};

export default CourseEnrollmentDisplay;
